// Antd locale imports
import ptBR from 'antd/es/locale/pt_BR'
import enGB from 'antd/es/locale/en_GB'
import enUS from 'antd/es/locale/en_US'
import esAR from 'antd/es/locale/es_ES'

export const antdLocales = {
  'pt-BR': ptBR,
  'en-GB': enGB,
  'en-US': enUS,
  'es-AR': esAR,
}
